module.exports = __webpack_public_path__ + "static/media/logo_black.147c3749.png";